module.exports = __webpack_public_path__ + "static/5-14ba07c7b6b6532cb58766c2f52eeba0.jpg";